// Search
import { t } from "../texts.js";
let searchIconClose = document.querySelector(".js-close-search");
let searchIconOpen = document.querySelectorAll(".js-open-search");

if (searchIconClose) {
  let searchElement = document.querySelector(".search");
  let menuIconButton = document.querySelector(".menu-icon");
  let menuText = menuIconButton.querySelector(".menu-icon__text");
  let menuMobileContainer = document.querySelector(".navigation-mobile");

  searchIconClose.addEventListener("click", (e) => {
    searchElement.classList.remove("open");
    menuIconButton.classList.remove("open");
    menuText.textContent = t("Menu");
  });
}

if (searchIconOpen.length > 0) {
  let searchElement = document.querySelector(".search");
  let menuIconButton = document.querySelector(".menu-icon");
  let menuText = menuIconButton.querySelector(".menu-icon__text");
  let menuMobileContainer = document.querySelector(".navigation-mobile");

  Array.from(searchIconOpen).forEach((openSearchButton) => {
    openSearchButton.addEventListener("click", () => {
      searchElement.classList.add("open");
      menuIconButton.classList.add("open");
      menuMobileContainer.classList.add("search-active");
      menuText.textContent = t("Close");
    });
  });
}
